import { isValidPhoneNumber } from "libphonenumber-js"

export const phoneNumberValidation = (phoneNumber) => {
  if(phoneNumber){
    return isValidPhoneNumber(phoneNumber)
  }
  return false
}